/* eslint-env browser */
import { Component, Input, OnInit, Output, EventEmitter,  OnDestroy,  ChangeDetectorRef, ComponentRef, ViewContainerRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TvangebotimagevideoComponent } from '@app/components/modals/tvangebotimagevideo/tvangebotimagevideo.component';
import { Customer } from '@app/models/customers/Customer';
import { BookingcomOffer } from '@app/models/offerpack/BookingcomOffer';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { AuthService } from '@app/services/auth.service';
import { ImportService } from '@app/services/import.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommentComponent } from '../comment/comment.component';
import { BoolingcomDetailComponent } from '../offerpackdetailmodal/boolingcom-detail/boolingcom-detail.component';

@Component({
    selector: 'clever-offerpackbookingcomcard',
    templateUrl: './offerpackbookingcomcard.component.html',
    styleUrls: ['./offerpackbookingcomcard.component.scss'],
    standalone: false
})
export class OfferpackbookingcomcardComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject();
    @Input() offerid: string;
    @Input() index: number;
    @Output() removeFromList = new EventEmitter<string>();
    @Output() changeindex = new EventEmitter<{ dragedindex: number; dropindex: number }>();

    desktopTemplate: string = 'xl';
    currentCustomer: Customer;
    currentpartner: Partner;
    component: ComponentRef<any>;

    sendRegSub: Subscription;
    sendBack: Subscription;

    categoryAr = [];
    showDetail: boolean = false;
    showImmages: boolean = true;

    datas: BookingcomOffer;
    dauer: any;
    constructor(
        private auth: AuthService,
        private authguad: AuthGuardService,
        private importService: ImportService,
        private cdr: ChangeDetectorRef,
        private viewContainerRef: ViewContainerRef,
        private dialog: MatDialog,
        protected mediaObserver: BreakpointObserver
    ) { }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    ngOnInit(): void {
        this.initMedia();
        this.initCustomer();
        this.initPartner();
    }

    async initPartner() {
        this.authguad.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(partner => {
            this.currentpartner = partner;
            if (this.currentpartner?.partnerid?.length > 0) {
                this.initData();
            }
        });
    }

    async initCustomer() {
        this.auth.auth$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((customer: Customer) => {
            this.currentCustomer = customer;
        });
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
        this.cdr.detectChanges();
    }

    initData() {
        const target = {
            offerid: this.offerid,
            partnerid: this.currentpartner?.partnerid
        };
        this.importService.request(target, 'getofferbyid').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res && !res.error) {
                if (res.CustomOffer?.Accommodation?.ImageUrls?.ImageUrl?.length > 0 && res.firstBilder?.length > 0) {
                    const pos = res.CustomOffer.Accommodation.ImageUrls.ImageUrl.indexOf(res.firstBilder);
                    res.CustomOffer.Accommodation.ImageUrls.ImageUrl = this.changeBilderPos(res.CustomOffer.Accommodation.ImageUrls.ImageUrl, pos);
                }
                this.datas = res;
                this.datas.firstBilderPos = 0;
                this.initRating(this.datas?.CustomOffer?.Accommodation?.StarsCount);
            }
            this.cdr.detectChanges();
        });
    }

    initRating(category) {
        const catg = Number(String(category).replace(/,/g, '.'));
        for (let i = 0; i < Math.floor(catg); i++) {
            this.categoryAr.push(1);
        }
        if (catg > Math.floor(catg)) {
            this.categoryAr.push(0.5);
        }
    }

    async removeFromListF() {
        this.removeFromList.emit(this.offerid);
    }

    async gotoBuchen() {
        window.open(this.datas?.CustomOffer?.BookingUrl, '_blank', 'noopener');
    }

    openImageModal(ev) {
        const target = {
            disableClose: true,
            panelClass: ['full-screen-modal'],
            data: {
                hotel: null,
                images: this.datas?.CustomOffer?.Accommodation?.ImageUrls?.ImageUrl,
                videos: [],
                current: ev,
                to800: true,
                desktopTemplate: this.desktopTemplate,
                showSave: true
            }
        }
        const resf = this.dialog.open(TvangebotimagevideoComponent, target);
        resf.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((pos) => {
            if (pos !== this.datas.firstBilderPos) {
                this.datas.firstBilderPos = pos;
                this.saveImagesList();
            }
        });
    }

    gotoOffers() {
        window.open(this.datas?.CustomOffer?.BackReference, '_blank', 'noopener');
    }

    saveImagesList() {
        const target = {
            offerid: this.offerid,
            firstBilder: this.datas.CustomOffer.Accommodation.ImageUrls.ImageUrl[this.datas.firstBilderPos],
            partnerid: this.currentpartner?.partnerid
        };
        this.importService.request(target, 'updateImageList').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res?.error) {
                // console.log(res);
            } else {
                if (this.datas.CustomOffer.Accommodation.ImageUrls.ImageUrl) {
                    this.datas.CustomOffer.Accommodation.ImageUrls.ImageUrl = this.changeBilderPos(this.datas.CustomOffer.Accommodation.ImageUrls.ImageUrl, this.datas.firstBilderPos);
                    this.showImmages = false;
                    this.datas.firstBilderPos = 0;
                    this.cdr.detectChanges();
                    setTimeout(() => {
                        this.showImmages = true;
                        this.cdr.detectChanges();
                    });
                }
            }
            this.cdr.detectChanges();
        });
    }

    changeBilderPos(targetArray, pos): string[] {
        if (targetArray?.length > 0) {
            targetArray.splice(0, 0, targetArray[pos]);
            targetArray.splice(pos + 1, 1);
        }
        return targetArray;
    }

    async openDetail() {
        if (this.component) {
            this.component.destroy();
        }
        this.sendRegSub?.unsubscribe();
        this.component = this.viewContainerRef.createComponent(BoolingcomDetailComponent);
        this.component.instance.datas = this.datas;
        this.component.instance.id = this.index;
        this.sendRegSub = this.component.instance.sendReg.subscribe((ev) => {
            if (ev) {
                this.gotoBuchen();
            }
        });
        this.showDetail = true;
        this.cdr.detectChanges();
    }

    closeModal(ev) {
        if (ev) {
            this.showDetail = false;
            this.cdr.detectChanges();
        }
    }

    async dragStart(ev: DragEvent, index: number) {
        ev.stopPropagation();
        ev.dataTransfer.effectAllowed = 'move';
        ev.dataTransfer.setData('dragedindex', index + '');
    };

    async dragOver(event: DragEvent) {
        event.preventDefault();
    }

    async dropp(ev: DragEvent) {
        ev.stopPropagation();
        const dragedindex = ev.dataTransfer.getData('dragedindex')
        if (Number(dragedindex) > 0 && Number(dragedindex) !== this.index) {
            this.changeindex.emit({ dragedindex: Number(dragedindex) - 1, dropindex: this.index - 1 });
        }
    }

    async openSetComment() {
        let target = {} as MatDialogConfig;
        if (this.desktopTemplate !== 'xs' && this.desktopTemplate !== 'sm') {
            target = {
                width: '600px',
                data: {
                    title: 'Angebot Nr.' + this.index,
                    message: this.datas.extracomment
                },
                autoFocus: false
            };
        } else {
            target = {
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                // panelClass: 'customModal',
                data: {
                    title: 'Angebot Nr.' + this.index,
                    message: this.datas.extracomment
                },
                autoFocus: false
            }
        }
        const resf = this.dialog.open(CommentComponent, target);
        resf.afterClosed().pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((data) => {
            if (data) {
                this.datas.extracomment = data?.message;
                this.saveComment(this.datas.extracomment);
            }
        });
    }

    saveComment(extracomment) {
        const target = {
            offerid: this.offerid,
            extracomment: extracomment,
            partnerid: this.currentpartner?.partnerid
        };
        this.importService.request(target, 'saveComment').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res?.error) {
                console.log(res);
            }
        });
    }
}
